/**
 * Replace space and other special characters from a given string with underscores.
 *
 * @param {string} str
 * @returns {string}
 */
export default function toIdString(str) {
  return `${str}`.replace(/[^A-Za-z0-9]/g, '_')
}
